<template>
  <div class="export-section">
    <el-button
      type="primary"
      :disabled="disabled"
      :loading="loading"
      size="medium"
      @click="exportData"
      >Export CSV</el-button
    >
  </div>
</template>

<script>
import XLSX from "xlsx";
import moment from "moment";
import support from "@/mixins/support.js";
import apiConstants from "@/apiConstants.js";

export default {
  name: "CsvFormat",
  props: {
    downloadApiDetails: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      loading: false,
      dataToExport: [],
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  methods: {
    async exportData() {
      this.loading = true;
      const endPointData = this.downloadApiDetails;
      await this.$http
        .post(
          endPointData.url,
          {
            method: endPointData.method,
            params: endPointData.params
          },
          {
            headers: {
              "data-baseurl-namespace": endPointData.nameSpace
            }
          }
        )
        .then(response => {
          this.loading = false;
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            if (!resData.list.length) {
              this.notification(
                "Error",
                `No ${endPointData.reportFor} available`,
                "danger"
              );
              return;
            }
            this.dataToExport = resData.list;
            this.exportCsv();
          }
        })
        .catch(err => {
          this.notification("Error", err, "danger");
        });
    },

    exportCsv() {
      const reportFor = this.downloadApiDetails.reportFor;
      let headerColumns = [];
      const reportOf = `${reportFor}-reports`;
      const atMoment = moment().format("MMDDYYYYhhmmssA");
      const fileName = `${reportOf}-${atMoment}.csv`;

      switch (reportFor) {
        case "billings": {
          headerColumns = [
            "Date",
            "Transaction Type",
            "Activity",
            "Charge",
            "Balance",
            "Status"
          ];
          const dataToExport = this.dataToExport.map(function(item) {
            const itemObj = {};
            itemObj[headerColumns[0]] = item.done_at;
            itemObj[headerColumns[1]] = item.is_credit ? "Credit" : "Debit";
            itemObj[headerColumns[2]] =
              item.target_type_object && item.target_type_object.name;
            itemObj[headerColumns[3]] =
              item.target &&
              support.methods.formatPrice(item.target.payment_method_charge);
            itemObj[headerColumns[4]] = support.methods.formatPrice(
              item.balance
            );
            itemObj[headerColumns[5]] =
              item.target && item.target.status && item.target.status.label;

            return itemObj;
          });

          const reportsSheet = XLSX.utils.json_to_sheet(dataToExport);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, reportsSheet, reportFor);
          XLSX.writeFile(wb, fileName);
          break;
        }

        default: {
          // Default comes here
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  color: #140508;
  font-weight: 500;
}
</style>
